import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Chart1 from "./Chart-1/Chart1";
import Chart2 from "./Chart-2/Chart2";
import logo from "./assets/img/Logo.png";
import ChartAtf from "./assets/img/Chart-ATF.jpg";
import ModalInfo from "./Chart-1/Modal/ModalInfo";
import Info from "./Info/info";
import Instruction from "./Info/instruction";
import "./App.css";

export default function App() {
  return (
    <div>
      <div className="container">
        <div className="main-container">
          <Router>
            <nav className="navbar navbar-expand-lg navbar-light bg-light fontnavbar">
              <a href="#" className="navbar-brand1">
                <img src={logo} alt="Logo" />
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                  <li className="nav-item active">
                  </li>
                  <li className="nav-item">
                    <div className="dropdown">
                      <button
                        className="nav-link-dorpDown"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        نمودارها
                      </button>
                      <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <Link className="dropdown-item" to="/chart-1">
                          استاندارها
                        </Link>
                        <Link className="dropdown-item" to="/chart-2">
                         روغن دنده اتوماتیک 
                        </Link>
                      </div>
                    </div>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#"
                      className="nav-link"
                      data-toggle="modal"
                      data-target="#exampleModal"
                    >
                      راهنما 
                    </Link>
                  </li>
                
                  <li className="nav-item">
                  </li>
                  <li className="nav-item">
                    <ModalInfo />
                  </li>
                </ul>
              </div>
            </nav>
            <Switch>
              <Route path="/chart-1">
                <Chart1 />
              </Route>
              <Route path="/chart-2">
                <Chart2 />
                <div className="row">
              <div className="col-12">
                <p className="HeadRead">
                  جدول مشخصات روغن های انتقال اتوماتیک
                </p>
              </div>
            </div>
                <img src={ChartAtf} alt="ChartAtf" />
              </Route>
              <Route path="/">
                <Chart1 />
              </Route>
            </Switch>
          </Router>
          <div className="row">
            <div className="col-margin">
              <div className="col-12">
              </div>
            </div>
          </div>
          <div className="footer">
            <div className="row">
              <div className="col-12">
                <p className="copyright">
                  تمامی حقوق این سایت محفوظ و متعلق به شرکت اتحاد روانکاران
                  ایرانیان میباشد ©{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
